import { defaultEntryPointConfig } from './default-entry-point-config';
import { type Config } from './types';

export const entryPointConfig: Config = defaultEntryPointConfig;
